import { Icon, Modal, Radio, Typography } from '@smartgift/frontend-toolkit';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { ShareGiftPreviewModal } from '../ShareGiftPreview';

const GiftPreviewContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

function GiftPreviewModal({ isModalOpen, onModalOpen, previewLink }) {
  const { t } = useTranslation();
  const [checkedOption, setCheckedOption] = React.useState('');
  const [isShareGiftPreviewModalOpen, setIsShareGiftPreviewModalOpen] = React.useState(false);

  const PreviewCheckboxLabel = (
    <>
      <b>{t('preview')}</b> <p>({t('previewCheckboxLabel')})</p>{' '}
    </>
  );

  const ShareCheckboxLabel = (
    <>
      <b>{t('share')}</b> <p>({t('shareCheckboxLabel')})</p>{' '}
    </>
  );

  const onClickNext = () => {
    if (checkedOption === 'preview') {
      window.open(previewLink, '_blank');
    } else {
      setIsShareGiftPreviewModalOpen(true);
    }

    onModalOpen(false);
  };

  return (
    <>
      <Modal
        isOpen={isModalOpen}
        onRequestClose={onModalOpen}
        title={t('giftPreview')}
        primaryButtonProps={{
          children: t('next'),
          endIcon: <Icon name="next" />,
          onClick: onClickNext,
          disabled: !checkedOption
        }}
        secondaryButtonProps={{
          children: t('cancel'),
          onClick: () => onModalOpen(false)
        }}
        size="sm"
      >
        <GiftPreviewContent>
          <Typography variant="body1Bold" style={{ marginBottom: 16 }}>
            {t('previewOrShareQuestion')}
          </Typography>

          <Radio
            label={PreviewCheckboxLabel}
            value="preview"
            checked={checkedOption === 'preview'}
            onChange={() => setCheckedOption('preview')}
          />

          <Radio
            style={{ marginTop: 8 }}
            value="share"
            checked={checkedOption === 'share'}
            onChange={() => setCheckedOption('share')}
            label={ShareCheckboxLabel}
          />
        </GiftPreviewContent>
      </Modal>

      <ShareGiftPreviewModal
        isModalOpen={isShareGiftPreviewModalOpen}
        onModalOpen={setIsShareGiftPreviewModalOpen}
        onBack={() => onModalOpen(true)}
      />
    </>
  );
}

export { GiftPreviewModal };
